

export const checkHashLink = () => {
  if (window.location.hash) {
    const hash = window.location.hash.replace("#", "");
    const el = document.documentElement.querySelector('#' + hash );
    if (el) {
      // scroll to element (smooth)
      setTimeout(() => {
        el.parentNode.scrollIntoView({behavior: "smooth"});
      }, 400);
    }
  }
}